// Convite para votar na HeroSpark no Prêmio Reclame AQUI 2026, exibido ao
// aluno quando ele conclui uma aula. Fora da janela da votação nada aparece,
// sem depender de deploy.
const VOTING_STARTS_AT = new Date('2026-09-02T00:00:00-03:00')
const VOTING_ENDS_AT = new Date('2026-11-05T00:00:00-03:00')

export const PREMIO_RA_VOTING_URL =
  'https://www.reclameaqui.com.br/premio/votacao/servicos/marketing-digital/'
export const PREMIO_RA_CATEGORY = 'Serviços: Marketing Digital'

// Espera até o convite entrar, contada da conclusão da aula: dá tempo da
// animação de "aula concluída" terminar antes de abrir o modal.
export const PREMIO_RA_PROMPT_DELAY_IN_MS = 1500

// Marco de progresso que os players reportam ao chegar ao fim da reprodução
// (todos emitem 25/50/75/100). É o sinal de "acabou" usado para não abrir o
// convite com o vídeo ainda tocando.
export const PREMIO_RA_MEDIA_END_PROGRESS = 100

export function isPremioRaVotingOpen(now = new Date()) {
  return now >= VOTING_STARTS_AT && now < VOTING_ENDS_AT
}
